import React from 'react';

const MenuIcons = {
  shield: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 3.99982L11.6314 2.56892C11.875 2.52325 12.125 2.52325 12.3686 2.56892L20 3.99982V11.9031C20 15.6958 18.0462 19.221 14.83 21.2311L12.53 22.6686C12.2057 22.8712 11.7943 22.8712 11.47 22.6686L9.17001 21.2311C5.95382 19.221 4 15.6958 4 11.9031L4 3.99982Z"
        stroke="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1748 14.75C10.9352 14.75 10.6956 14.6542 10.504 14.4625L8.5873 12.5458C8.20397 12.1625 8.20397 11.5875 8.5873 11.2042C8.97064 10.8208 9.59355 10.8208 9.92897 11.2042L11.1748 12.45L14.3373 9.2875C14.7206 8.90417 15.2956 8.90417 15.679 9.2875C16.0623 9.67083 16.0623 10.2458 15.679 10.6292L11.8456 14.4625C11.654 14.6542 11.4144 14.75 11.1748 14.75Z"
        fill="white"
      />
    </svg>
  ),
  folder: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.64645 5.35355L9.79289 5.5H10H20.5C21.0523 5.5 21.5 5.94772 21.5 6.5V17.5C21.5 18.0523 21.0523 18.5 20.5 18.5H3.5C2.94772 18.5 2.5 18.0523 2.5 17.5V3.5C2.5 2.94772 2.94772 2.5 3.5 2.5H6.37868C6.6439 2.5 6.89825 2.60536 7.08579 2.79289L9.64645 5.35355Z"
        stroke="white"
      />
    </svg>
  ),
  bell: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.55827 6.97553L8.05522 7.03075L7.55827 6.97553ZM7 12V12.5H7.44752L7.49694 12.0552L7 12ZM17 12L16.5031 12.0552L16.5525 12.5H17V12ZM16.4417 6.97554L16.9387 6.92032V6.92032L16.4417 6.97554ZM8.05522 7.03075C8.27856 5.02069 9.97757 3.5 12 3.5V2.5C9.46802 2.5 7.34094 4.40382 7.06133 6.92032L8.05522 7.03075ZM7.49694 12.0552L8.05522 7.03075L7.06133 6.92032L6.50306 11.9448L7.49694 12.0552ZM5.5 12.5H7V11.5H5.5V12.5ZM4.5 13.5C4.5 12.9477 4.94772 12.5 5.5 12.5V11.5C4.39543 11.5 3.5 12.3954 3.5 13.5H4.5ZM5.5 14.5C4.94772 14.5 4.5 14.0523 4.5 13.5H3.5C3.5 14.6046 4.39543 15.5 5.5 15.5V14.5ZM18.5 14.5H5.5V15.5H18.5V14.5ZM19.5 13.5C19.5 14.0523 19.0523 14.5 18.5 14.5V15.5C19.6046 15.5 20.5 14.6046 20.5 13.5H19.5ZM18.5 12.5C19.0523 12.5 19.5 12.9477 19.5 13.5H20.5C20.5 12.3954 19.6046 11.5 18.5 11.5V12.5ZM17 12.5H18.5V11.5H17V12.5ZM15.9448 7.03075L16.5031 12.0552L17.4969 11.9448L16.9387 6.92032L15.9448 7.03075ZM12 3.5C14.0224 3.5 15.7214 5.02069 15.9448 7.03075L16.9387 6.92032C16.6591 4.40383 14.532 2.5 12 2.5V3.5Z"
        fill="white"
      />
      <rect x="10" y="16" width="4" height="4" rx="2" fill="white" />
    </svg>
  ),
  clipboard: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="path-2-inside-1" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 3H6C4.89543 3 4 3.89543 4 5V20.5C4 21.6046 4.89543 22.5 6 22.5H18C19.1046 22.5 20 21.6046 20 20.5V5C20 3.89543 19.1046 3 18 3H16V3.5C16 4.32843 15.3284 5 14.5 5H9.5C8.67157 5 8 4.32843 8 3.5V3Z"
        />
      </mask>
      <path
        d="M8 3H9V2H8V3ZM16 3V2H15V3H16ZM6 4H8V2H6V4ZM5 5C5 4.44772 5.44772 4 6 4V2C4.34315 2 3 3.34315 3 5H5ZM5 20.5V5H3V20.5H5ZM6 21.5C5.44771 21.5 5 21.0523 5 20.5H3C3 22.1569 4.34315 23.5 6 23.5V21.5ZM18 21.5H6V23.5H18V21.5ZM19 20.5C19 21.0523 18.5523 21.5 18 21.5V23.5C19.6569 23.5 21 22.1569 21 20.5H19ZM19 5V20.5H21V5H19ZM18 4C18.5523 4 19 4.44772 19 5H21C21 3.34315 19.6569 2 18 2V4ZM16 4H18V2H16V4ZM15 3V3.5H17V3H15ZM15 3.5C15 3.77614 14.7761 4 14.5 4V6C15.8807 6 17 4.88071 17 3.5H15ZM14.5 4H9.5V6H14.5V4ZM9.5 4C9.22386 4 9 3.77614 9 3.5H7C7 4.88071 8.11929 6 9.5 6V4ZM9 3.5V3H7V3.5H9Z"
        fill="white"
        mask="url(#path-2-inside-1)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 2H14.5C14.7761 2 15 2.22386 15 2.5V3.5C15 3.77614 14.7761 4 14.5 4H9.5C9.22386 4 9 3.77614 9 3.5V2.5C9 2.22386 9.22386 2 9.5 2H11C11 1.44772 11.4477 1 12 1C12.5523 1 13 1.44772 13 2Z"
        fill="white"
      />
      <rect x="7" y="10" width="5" height="2" rx="1" fill="white" />
      <rect x="7" y="14" width="9" height="2" rx="1" fill="white" />
    </svg>
  ),
  smile: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="3.5" y="3.5" width="17" height="17" rx="8.5" stroke="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.16806 14.5548C5.8617 14.0953 5.98588 13.4744 6.44541 13.1681C6.90493 12.8617 7.5258 12.9859 7.83216 13.4454C8.98919 15.181 10.3544 16.0001 12.0001 16.0001C13.6458 16.0001 15.011 15.181 16.1681 13.4454C16.4744 12.9859 17.0953 12.8617 17.5548 13.1681C18.0143 13.4744 18.1385 14.0953 17.8322 14.5548C16.3225 16.8193 14.3544 18.0001 12.0001 18.0001C9.64578 18.0001 7.67769 16.8193 6.16806 14.5548Z"
        fill="white"
      />
    </svg>
  ),
  thunder: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
        stroke="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 16.8229C11 17.6144 12.0669 17.8662 12.4208 17.1584L15.4573 11.0854C15.7066 10.5867 15.344 10 14.7865 10H12V7.17705C12 6.38563 10.9331 6.13377 10.5792 6.84164L7.54271 12.9146C7.29337 13.4133 7.65599 14 8.21353 14H11V16.8229Z"
        fill="white"
      />
    </svg>
  ),
  question: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12Z"
        stroke="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5909 13.2089V14.8679H11.8509C14.3919 14.8679 16.3869 12.9149 16.3869 10.3949C16.3869 7.87488 14.3919 5.92188 11.8509 5.92188C9.30994 5.92188 7.33594 7.87488 7.33594 10.3949H9.12094C9.12094 8.79888 10.2339 7.58088 11.8509 7.58088C13.4469 7.58088 14.6019 8.79888 14.6019 10.3949C14.6019 11.9909 13.4469 13.2089 11.8509 13.2089H10.5909ZM11.9999 15.9999C11.4477 15.9999 10.9999 16.4476 10.9999 16.9999C10.9999 17.5522 11.4477 17.9999 11.9999 17.9999C12.5522 17.9999 12.9999 17.5522 12.9999 16.9999C12.9999 16.4476 12.5522 15.9999 11.9999 15.9999Z"
        fill="white"
      />
    </svg>
  ),
  binocular: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.8433 16L13.3263 15.8706L13.227 15.5H12.8433V16ZM11.1563 16V15.5H10.7727L10.6734 15.8706L11.1563 16ZM10.985 16.6393L11.468 16.7687V16.7687L10.985 16.6393ZM2.20098 14.2856L1.71802 14.1562L2.20098 14.2856ZM3.92068 7.86763L4.40365 7.99704L3.92068 7.86763ZM9.48955 4.65245L9.36014 5.13541L9.48955 4.65245ZM11.9998 6.38339L11.5942 6.67576L11.9998 7.23846L12.4054 6.67576L11.9998 6.38339ZM14.5101 4.65245L14.6395 5.13541L14.5101 4.65245ZM20.079 7.86763L20.5619 7.73822L20.079 7.86763ZM21.7987 14.2856L21.3157 14.4151L21.7987 14.2856ZM13.0146 16.6393L13.4976 16.5099L13.0146 16.6393ZM12.8433 15.5H11.1563V16.5H12.8433V15.5ZM10.6734 15.8706L10.5021 16.5099L11.468 16.7687L11.6393 16.1294L10.6734 15.8706ZM10.5021 16.5099C9.92359 18.6688 7.70449 19.95 5.54558 19.3715L5.28676 20.3375C7.97914 21.0589 10.7466 19.4611 11.468 16.7687L10.5021 16.5099ZM5.54558 19.3715C3.38666 18.7931 2.10547 16.574 2.68395 14.4151L1.71802 14.1562C0.9966 16.8486 2.59438 19.616 5.28676 20.3375L5.54558 19.3715ZM2.68395 14.4151L4.40365 7.99704L3.43772 7.73822L1.71802 14.1562L2.68395 14.4151ZM4.40365 7.99704C4.98213 5.83813 7.20122 4.55693 9.36014 5.13541L9.61896 4.16948C6.92658 3.44806 4.15914 5.04584 3.43772 7.73822L4.40365 7.99704ZM9.36014 5.13541C10.2973 5.38652 11.0681 5.94585 11.5942 6.67576L12.4054 6.09102C11.7495 5.18106 10.7867 4.48237 9.61896 4.16948L9.36014 5.13541ZM12.4054 6.67576C12.9316 5.94585 13.7023 5.38652 14.6395 5.13541L14.3807 4.16948C13.2129 4.48237 12.2501 5.18106 11.5942 6.09102L12.4054 6.67576ZM14.6395 5.13541C16.7984 4.55693 19.0175 5.83813 19.596 7.99704L20.5619 7.73822C19.8405 5.04584 17.0731 3.44806 14.3807 4.16948L14.6395 5.13541ZM19.596 7.99704L21.3157 14.4151L22.2816 14.1562L20.5619 7.73822L19.596 7.99704ZM21.3157 14.4151C21.8942 16.574 20.613 18.7931 18.4541 19.3715L18.7129 20.3375C21.4053 19.616 23.003 16.8486 22.2816 14.1562L21.3157 14.4151ZM18.4541 19.3715C16.2951 19.95 14.076 18.6688 13.4976 16.5099L12.5316 16.7687C13.2531 19.4611 16.0205 21.0589 18.7129 20.3375L18.4541 19.3715ZM13.4976 16.5099L13.3263 15.8706L12.3603 16.1294L12.5316 16.7687L13.4976 16.5099ZM17.4562 18.6052C19.2563 18.6052 20.6843 17.0964 20.6843 15.2744H19.6843C19.6843 16.5792 18.6695 17.6052 17.4562 17.6052V18.6052ZM20.6843 15.2744C20.6843 13.4524 19.2563 11.9436 17.4562 11.9436V12.9436C18.6695 12.9436 19.6843 13.9696 19.6843 15.2744H20.6843ZM17.4562 11.9436C15.6561 11.9436 14.228 13.4524 14.228 15.2744H15.228C15.228 13.9696 16.2428 12.9436 17.4562 12.9436V11.9436ZM14.228 15.2744C14.228 17.0964 15.6561 18.6052 17.4562 18.6052V17.6052C16.2428 17.6052 15.228 16.5792 15.228 15.2744H14.228ZM6.54347 18.6052C8.34358 18.6052 9.77164 17.0964 9.77164 15.2744H8.77164C8.77164 16.5792 7.75681 17.6052 6.54347 17.6052V18.6052ZM9.77164 15.2744C9.77164 13.4524 8.34358 11.9436 6.54347 11.9436V12.9436C7.75681 12.9436 8.77164 13.9696 8.77164 15.2744H9.77164ZM6.54347 11.9436C4.74336 11.9436 3.31529 13.4524 3.31529 15.2744H4.31529C4.31529 13.9696 5.33012 12.9436 6.54347 12.9436V11.9436ZM3.31529 15.2744C3.31529 17.0964 4.74336 18.6052 6.54347 18.6052V17.6052C5.33012 17.6052 4.31529 16.5792 4.31529 15.2744H3.31529Z"
        fill="white"
      />
    </svg>
  ),
  phone: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.2825 20.7875L19.2825 20.7875L19.2865 20.7853C19.7356 20.5363 20.1127 20.2849 20.4075 20.0287C20.698 19.7763 20.9325 19.4987 21.063 19.1905C21.1741 18.9369 21.2714 18.6121 21.3594 18.2292C21.4484 17.8422 21.5 17.5002 21.5 17.2159C21.5 17.0815 21.4882 16.9177 21.4285 16.7682C21.3792 16.6351 21.2942 16.5345 21.2277 16.4673C21.152 16.3906 21.0616 16.3193 20.9664 16.2529C20.7785 16.1219 20.5286 15.9806 20.2273 15.8295C20.0605 15.7332 19.8301 15.6054 19.5383 15.4469C19.2416 15.2859 18.9731 15.1379 18.7327 15.0029C18.501 14.8729 18.2837 14.7471 18.0809 14.6256C18.0256 14.5857 17.9183 14.5109 17.7685 14.4074C17.579 14.2766 17.4041 14.1691 17.2479 14.0938C17.0667 14.0063 16.8713 13.9545 16.6662 13.9545C16.4642 13.9545 16.2818 14.0252 16.1309 14.1112C15.9778 14.1985 15.8281 14.3182 15.6826 14.4564C15.4062 14.719 15.153 15.0045 14.9231 15.3125C14.723 15.5807 14.5117 15.8276 14.2896 16.0537C14.1864 16.1588 14.1091 16.2201 14.057 16.2523C14.0489 16.2573 14.0421 16.2612 14.0366 16.2642C14.0154 16.2595 13.985 16.2508 13.9443 16.2357C13.8346 16.1951 13.7673 16.1663 13.7321 16.1487L13.5085 16.5959L13.7321 16.1487C13.695 16.1301 13.6102 16.0815 13.4645 15.9915C13.3512 15.9216 13.253 15.8611 13.2013 15.8327L13.2014 15.8327C12.0692 15.2046 11.1064 14.4902 10.3081 13.6919C9.50976 12.8936 8.79537 11.9308 8.16734 10.7986L8.16731 10.7987C8.1389 10.747 8.07844 10.6488 8.0085 10.5355C7.91848 10.3898 7.86991 10.305 7.85133 10.2679L7.85133 10.2679C7.83373 10.2327 7.80492 10.1654 7.76433 10.0557C7.74922 10.015 7.7405 9.98457 7.73577 9.96345C7.73877 9.95788 7.74266 9.95109 7.74765 9.94302C7.77992 9.89094 7.8412 9.81361 7.94629 9.71036C8.17236 9.48826 8.41929 9.27703 8.68754 9.07685C8.99553 8.84701 9.28099 8.59382 9.54361 8.31739C9.68184 8.17188 9.80146 8.02221 9.88876 7.86905C9.97475 7.71818 10.0455 7.53576 10.0455 7.33381C10.0455 7.12867 9.99372 6.93328 9.90624 6.75209C9.83086 6.59594 9.72337 6.42098 9.59256 6.23153C9.48909 6.08168 9.41436 5.97441 9.37438 5.91916C9.25292 5.71627 9.12716 5.49902 8.99707 5.26731C8.86208 5.02686 8.7141 4.75838 8.55306 4.46174L8.11364 4.70028L8.55306 4.46174C8.39463 4.16988 8.26681 3.93954 8.17048 3.77267C8.01937 3.4714 7.87815 3.22148 7.74713 3.0336C7.68072 2.93837 7.60935 2.84804 7.53275 2.7723C7.46549 2.7058 7.36488 2.62082 7.23182 2.57146C7.08233 2.51176 6.91854 2.5 6.78409 2.5C6.49985 2.5 6.15777 2.55159 5.77079 2.64055C5.3879 2.72857 5.063 2.82589 4.80942 2.93703C4.50125 3.06749 4.2237 3.302 3.97129 3.59252C3.71513 3.88734 3.4637 4.26444 3.21471 4.71351L3.21469 4.7135L3.21251 4.71752C2.74462 5.5799 2.5 6.45382 2.5 7.33381C2.5 7.58558 2.51632 7.83373 2.54921 8.07807C2.58293 8.32855 2.64201 8.59761 2.72378 8.88381C2.80114 9.15455 2.8664 9.36711 2.9187 9.51451C2.96725 9.65133 3.05607 9.89171 3.18382 10.2324C3.31314 10.5772 3.38584 10.7756 3.40776 10.8414L3.40765 10.8414L3.41123 10.8514C3.71978 11.7153 4.08819 12.494 4.51862 13.1846C5.217 14.3073 6.16384 15.4619 7.35099 16.649C8.53814 17.8362 9.69274 18.783 10.8154 19.4814C11.506 19.9118 12.2847 20.2802 13.1486 20.5888L13.1486 20.5889L13.1586 20.5922C13.2244 20.6142 13.4228 20.6869 13.7676 20.8162C14.1083 20.9439 14.3487 21.0327 14.4855 21.0813C14.6329 21.1336 14.8454 21.1989 15.1162 21.2762C15.4024 21.358 15.6715 21.4171 15.9219 21.4508C16.1663 21.4837 16.4144 21.5 16.6662 21.5C17.5462 21.5 18.4201 21.2554 19.2825 20.7875Z"
        stroke="white"
      />
    </svg>
  ),
  exit: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.9613 10.2353L15.982 8.50656C15.9894 7.88735 16.7016 7.54339 17.1912 7.92258L21.2847 11.093C21.6562 11.3808 21.6746 11.9355 21.3229 12.2472L17.2088 15.8942C16.7249 16.3231 15.9613 15.9796 15.9613 15.3329V13.7647C14.813 13.6919 10.9097 13.7378 9.50713 13.7573C9.22787 13.7611 9 13.5359 9 13.2566V10.7398C9 10.4619 9.22348 10.2373 9.50139 10.2395C11.0215 10.2518 15.5026 10.2834 15.9613 10.2353Z"
        fill="white"
      />
      <path
        d="M14 7V4C14 3.44772 13.5523 3 13 3H3C2.44772 3 2 3.44772 2 4V20C2 20.5523 2.44772 21 3 21H13C13.5523 21 14 20.5523 14 20V17"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  workers: (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9996 11.7222C10.5575 11.7222 9.38844 10.5532 9.38844 9.11111H8.38844C8.38844 11.1055 10.0052 12.7222 11.9996 12.7222V11.7222ZM9.38844 9.11111C9.38844 7.66903 10.5575 6.5 11.9996 6.5V5.5C10.0052 5.5 8.38844 7.11675 8.38844 9.11111H9.38844ZM11.9996 6.5C13.4416 6.5 14.6107 7.66903 14.6107 9.11111H15.6107C15.6107 7.11675 13.9939 5.5 11.9996 5.5V6.5ZM14.6107 9.11111C14.6107 10.5532 13.4416 11.7222 11.9996 11.7222V12.7222C13.9939 12.7222 15.6107 11.1055 15.6107 9.11111H14.6107Z"
        fill="black"
      />
      <path
        d="M5.17534 8.66699C2.69276 8.66699 0.653107 10.0047 0.501167 12.8669C0.495114 12.981 0.501167 13.3336 0.890681 13.3336H2.36673H6.5"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.3247 8.66699C21.8072 8.66699 23.8469 10.0047 23.9988 12.8669C24.0049 12.981 23.9988 13.3336 23.6093 13.3336H22.1333H18"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.8666 6.73329C17.8357 6.73329 17 5.89757 17 4.86665C17 3.83573 17.8357 3 18.8666 3C19.8976 3 20.7333 3.83573 20.7333 4.86665C20.7333 5.89757 19.8976 6.73329 18.8666 6.73329Z"
        stroke="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.1667 6.73329C6.19762 6.73329 7.03334 5.89757 7.03334 4.86665C7.03334 3.83573 6.19762 3 5.1667 3C4.13578 3 3.30005 3.83573 3.30005 4.86665C3.30005 5.89757 4.13578 6.73329 5.1667 6.73329Z"
        stroke="black"
      />
      <path
        d="M5.00363 20.2993C5.30504 16.1232 8.31721 14 11.9886 14C15.7117 14 18.7705 16.0065 18.9984 20.3C19.0075 20.471 18.9984 21 18.4142 21C15.5328 21 11.251 21 5.56883 21C5.00312 21 4.98721 20.5268 5.00363 20.2993Z"
        stroke="black"
      />
    </svg>
  ),
  expenses: (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none">
      <circle cx={12} cy={12} r={9.5} stroke="#000" />
      <path
        d="M12.492 14.389H10.53V16H9.41v-1.611H8.197v-.926H9.41v-.803H8.197v-.92H9.41V7.47h3.147c.914 0 1.638.232 2.173.697.536.465.803 1.094.803 1.887 0 .832-.258 1.474-.773 1.927-.512.45-1.24.676-2.186.68H10.53v.803h1.963v.926zM10.53 11.74h2.028c.605 0 1.066-.142 1.383-.428.316-.285.474-.7.474-1.247 0-.497-.164-.897-.492-1.202-.328-.308-.772-.465-1.33-.468h-2.063v3.345z"
        fill="#000"
      />
    </svg>
  ),
  vk: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20" cy="20" r="20" fill="#5181B8" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.7577 13.7804C32.943 13.1624 32.7577 12.7083 31.8757 12.7083H28.959C28.2174 12.7083 27.8755 13.1005 27.6901 13.5331C27.6901 13.5331 26.2068 17.1484 24.1057 19.4968C23.4259 20.1766 23.1168 20.3929 22.746 20.3929C22.5607 20.3929 22.2923 20.1766 22.2923 19.5587V13.7804C22.2923 13.0388 22.0771 12.7083 21.459 12.7083H16.8757C16.4122 12.7083 16.1335 13.0525 16.1335 13.3787C16.1335 14.0817 17.184 14.2438 17.2923 16.2215V20.5166C17.2923 21.4582 17.1223 21.629 16.7515 21.629C15.7627 21.629 13.3575 17.9975 11.931 13.8422C11.6515 13.0345 11.3711 12.7083 10.6257 12.7083H7.70899C6.87566 12.7083 6.70898 13.1005 6.70898 13.5331C6.70898 14.3057 7.6978 18.1373 11.3131 23.2048C13.7232 26.6656 17.119 28.5416 20.209 28.5416C22.063 28.5416 22.2923 28.1249 22.2923 27.4072V24.7916C22.2923 23.9582 22.468 23.7919 23.0551 23.7919C23.4876 23.7919 24.2293 24.0082 25.9597 25.6768C27.9373 27.6544 28.2633 28.5416 29.3757 28.5416H32.2923C33.1257 28.5416 33.5423 28.1249 33.302 27.3026C33.0389 26.4831 32.0947 25.2941 30.8419 23.8846C30.1621 23.0812 29.1424 22.2161 28.8333 21.7834C28.4008 21.2273 28.5244 20.98 28.8333 20.4856C28.8333 20.4856 32.3869 15.4798 32.7577 13.7804Z"
        fill="white"
      />
    </svg>
  ),
  tg: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40Z"
        fill="url(#paint0_linear)"
      />
      <path
        d="M16.3327 29.1666C15.6847 29.1666 15.7948 28.9219 15.5713 28.3049L13.666 22.0344L28.3327 13.3333"
        fill="#C8DAEA"
      />
      <path
        d="M16.332 29.1667C16.832 29.1667 17.0529 28.938 17.332 28.6667L19.9987 26.0737L16.6724 24.0679"
        fill="#A9C9DD"
      />
      <path
        d="M16.6726 24.0684L24.7326 30.0232C25.6524 30.5307 26.3161 30.2679 26.5452 29.1694L29.8261 13.7089C30.1619 12.3622 29.3127 11.7512 28.4327 12.1507L9.16773 19.5792C7.85273 20.1067 7.86057 20.8404 8.92807 21.1672L13.8719 22.7104L25.3174 15.4895C25.8577 15.1619 26.3537 15.3379 25.9467 15.6992"
        fill="url(#paint1_linear)"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="26.68"
          y1="6.68"
          x2="16.68"
          y2="30"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#37AEE2" />
          <stop offset="1" stopColor="#1E96C8" />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="22.5065"
          y1="20.0016"
          x2="25.6278"
          y2="27.1131"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EFF7FC" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
      </defs>
    </svg>
  ),
  phone2: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20" cy="20" r="20" fill="#DBB612" />
      <path
        d="M28.9616 24.9474C28.9872 25.0071 29 25.0966 29 25.2159C29 25.446 28.9574 25.7464 28.8722 26.1172C28.7869 26.4879 28.6974 26.7798 28.6037 26.9929C28.4247 27.419 27.9048 27.8707 27.044 28.348C26.2429 28.7827 25.4503 29 24.6662 29C24.4361 29 24.2102 28.9851 23.9886 28.9553C23.767 28.9254 23.522 28.8722 23.2536 28.7955C22.9851 28.7188 22.7848 28.657 22.6527 28.6101C22.5206 28.5632 22.2841 28.4759 21.9432 28.348C21.6023 28.2202 21.3935 28.1435 21.3168 28.1179C20.4815 27.8196 19.7358 27.4659 19.0795 27.0568C17.9972 26.3835 16.8722 25.4631 15.7045 24.2955C14.5369 23.1278 13.6165 22.0028 12.9432 20.9205C12.5341 20.2642 12.1804 19.5185 11.8821 18.6832C11.8565 18.6065 11.7798 18.3977 11.652 18.0568C11.5241 17.7159 11.4368 17.4794 11.3899 17.3473C11.343 17.2152 11.2812 17.0149 11.2045 16.7464C11.1278 16.478 11.0746 16.233 11.0447 16.0114C11.0149 15.7898 11 15.5639 11 15.3338C11 14.5497 11.2173 13.7571 11.652 12.956C12.1293 12.0952 12.581 11.5753 13.0071 11.3963C13.2202 11.3026 13.5121 11.2131 13.8828 11.1278C14.2536 11.0426 14.554 11 14.7841 11C14.9034 11 14.9929 11.0128 15.0526 11.0384C15.206 11.0895 15.4318 11.4134 15.7301 12.0099C15.8239 12.1719 15.9517 12.402 16.1136 12.7003C16.2756 12.9986 16.4247 13.2692 16.5611 13.5121C16.6974 13.755 16.8295 13.983 16.9574 14.196C16.983 14.2301 17.0575 14.3366 17.1811 14.5156C17.3047 14.6946 17.3963 14.8459 17.456 14.9695C17.5156 15.093 17.5455 15.2145 17.5455 15.3338C17.5455 15.5043 17.424 15.7173 17.1811 15.973C16.9382 16.2287 16.674 16.4631 16.3885 16.6761C16.103 16.8892 15.8388 17.1151 15.5959 17.3537C15.353 17.5923 15.2315 17.7884 15.2315 17.9418C15.2315 18.0185 15.2528 18.1143 15.2955 18.2294C15.3381 18.3445 15.3743 18.4318 15.4041 18.4915C15.4339 18.5511 15.4936 18.6534 15.5831 18.7983C15.6726 18.9432 15.7216 19.0241 15.7301 19.0412C16.3778 20.2088 17.1193 21.2102 17.9545 22.0455C18.7898 22.8807 19.7912 23.6222 20.9588 24.2699C20.9759 24.2784 21.0568 24.3274 21.2017 24.4169C21.3466 24.5064 21.4489 24.5661 21.5085 24.5959C21.5682 24.6257 21.6555 24.6619 21.7706 24.7045C21.8857 24.7472 21.9815 24.7685 22.0582 24.7685C22.2116 24.7685 22.4077 24.647 22.6463 24.4041C22.8849 24.1612 23.1108 23.897 23.3239 23.6115C23.5369 23.326 23.7713 23.0618 24.027 22.8189C24.2827 22.576 24.4957 22.4545 24.6662 22.4545C24.7855 22.4545 24.907 22.4844 25.0305 22.544C25.1541 22.6037 25.3054 22.6953 25.4844 22.8189C25.6634 22.9425 25.7699 23.017 25.804 23.0426C26.017 23.1705 26.245 23.3026 26.4879 23.4389C26.7308 23.5753 27.0014 23.7244 27.2997 23.8864C27.598 24.0483 27.8281 24.1761 27.9901 24.2699C28.5866 24.5682 28.9105 24.794 28.9616 24.9474Z"
        fill="white"
      />
    </svg>
  ),
  rouble: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="10" r="9.5" stroke="currentColor" />
      <path
        d="M10.4922 12.3887H8.5293V14H7.41016V12.3887H6.19727V11.4629H7.41016V10.6602H6.19727V9.74023H7.41016V5.46875H10.5566C11.4707 5.46875 12.1953 5.70117 12.7305 6.16602C13.2656 6.63086 13.5332 7.25977 13.5332 8.05273C13.5332 8.88477 13.2754 9.52734 12.7598 9.98047C12.248 10.4297 11.5195 10.6562 10.5742 10.6602H8.5293V11.4629H10.4922V12.3887ZM8.5293 9.74023H10.5566C11.1621 9.74023 11.623 9.59766 11.9395 9.3125C12.2559 9.02734 12.4141 8.61133 12.4141 8.06445C12.4141 7.56836 12.25 7.16797 11.9219 6.86328C11.5938 6.55469 11.1504 6.39844 10.5918 6.39453H8.5293V9.74023Z"
        fill="currentColor"
      />
    </svg>
  ),
};

export default MenuIcons;
